export default "__VITE_ASSET__DN2Qcu93__"